import CloseIcon from "../../assets/svg/CloseIcon";
import InfoIcon from "../../assets/svg/InfoIcon";
import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";

interface NewVersionBannerProps {
  handleClose: () => void;
  openPopup: () => void;
}

function NewVersionBanner({
  handleClose,
  openPopup,
}: NewVersionBannerProps): JSX.Element {
  return (
    <div
      className="flex items-center justify-between min-w-[40vw] p-[2px] rounded-lg"
      style={{
        maxWidth: "700px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div className="flex items-center min-w-0">
        <InfoIcon className="mr-2 min-w-[24px] min-h-[24px]" />
        <CustomText
          text="Explore the new unified communication preferences"
          fontWeight="font-normal"
          fontSize="!text-sm md:text-base"
          className="truncate max-w-[50vw] md:max-w-[60vw] lg:max-w-[500px]"
        />
      </div>
      <div className="flex items-center flex-shrink-0 ml-2">
        <Button
          textInformation={{
            text: "Get started",
            fontWeight: "font-semibold",
            fontSize: "text-xs",
          }}
          onClick={openPopup}
          buttonTheme="transparent"
          className="text-white px-2 py-1 md:px-3 md:py-1.5"
        />
        <CloseIcon
          className="cursor-pointer ml-[16px] md:ml-[21px] w-5 h-5"
          onClick={(e: any) => {
            e.stopPropagation();
            handleClose();
          }}
          fill={`white`}
          stroke={"white"}
        />
      </div>
    </div>
  );
}

export default NewVersionBanner;
